var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(0),_c('InsertOrUpdateQuotation')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_c('strong',[_vm._v("Registro de cotización")])])]),_c('div',{staticClass:"col-md-12"},[_c('hr',{staticClass:"hrText",attrs:{"data-content":"♦"}})])])
}]

export { render, staticRenderFns }